module.exports = __webpack_public_path__ + "img/shadow-metrics-logo.02778acc.png";